import { from } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { gqlQuery } from "libs/awsLib";
import { queryValidateDuplicateDenounces } from "gql/index";

import {
  VALIDATE_DUPLICATE_DENOUNCES,
  validateDuplicateDenouncesFulfilled,
  validateDuplicateDenounceError,
} from "redux/actions/validateDuplicateDenounces";

export const validateDuplicateDenouncesEpic = action$ => action$.pipe(
  ofType(VALIDATE_DUPLICATE_DENOUNCES),
  mergeMap(({ payload }) =>
    from(
      gqlQuery(queryValidateDuplicateDenounces, {
        items: payload.items,
        reason: payload.reason || null,
      })
        .then(response => validateDuplicateDenouncesFulfilled(response.validateDuplicateDenounces))
        .catch(error => validateDuplicateDenounceError({ error }))
    )
  )
);
